'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext, useState } from 'react';
import { FacetType, RangeFacet, ValueFacet } from '@/src/lib/category/types.ts';
import ValueFilter from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/ValueFilter.tsx';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import RangeFilter from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/RangeFilter.tsx';
import { buildFilterChips, getFacetType, prepareFacets } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/lib/business/category-page-filters.ts';
import FilterChipBar from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/FilterChipBar.tsx';
import classNames from 'classnames';
import { useSearchParams } from 'next/navigation';
import ResetFiltersButton from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/ResetFiltersButton.tsx';
import OffCanvas from '@/src/app/components/OffCanvas/OffCanvas.tsx';
import OffcanvasFilters from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/OffcanvasFilters.tsx';
import { LayoutTemplateContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/LayoutTemplateProvider.tsx';
import Button, { ButtonSize } from '@/src/app/components/Button/Button.tsx';
import { IconName } from '@/src/app/components/Icon/types.ts';
const NR_HEADER_FACETS = 9;
type HeaderFiltersProps = {
  facets: Array<ValueFacet | RangeFacet>;
  dict: Dictionary;
  numFound: number;
};
const HeaderFiltersClient = function HeaderFilters(t0) {
  const $ = _c(43);
  const {
    facets,
    dict,
    numFound
  } = t0;
  const searchParams = useSearchParams();
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const {
    isPending
  } = useContext(LayoutTemplateContext);
  let chips;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== dict || $[1] !== facets || $[2] !== searchParams) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const validFacets = prepareFacets(facets);
      if (!validFacets.length) {
        t4 = null;
        break bb0;
      }
      chips = buildFilterChips(validFacets, searchParams, dict);
      const headerFacets = validFacets.splice(0, NR_HEADER_FACETS);
      t1 = "hidden md:grid grid-cols-6 gap-2 mt-6";
      t2 = "header-filters";
      let t5;
      if ($[8] !== dict) {
        t5 = (facet, index) => {
          const className = classNames({
            "col-span-2": index < 3,
            "md:hidden lg:block": index >= 3
          });
          if (getFacetType(facet) === FacetType.VALUES) {
            return <ValueFilter facet={facet as ValueFacet} className={className} key={facet.name} />;
          }
          if (getFacetType(facet) === FacetType.RANGE) {
            return <RangeFilter facet={facet as RangeFacet} dict={dict} className={className} key={facet.name} />;
          }
        };
        $[8] = dict;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      t3 = headerFacets.map(t5);
    }
    $[0] = dict;
    $[1] = facets;
    $[2] = searchParams;
    $[3] = chips;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    chips = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t5 = <div className={t1} data-testid={t2}>{t3}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setShowOffCanvas(true);
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== dict.category.filters.moreFilters || $[16] !== isPending) {
    t7 = <Button priority={true} size={ButtonSize.SMALL} onClick={t6} icon={IconName.TUNE} disabled={isPending} data-testid="more-filters-button">{dict.category.filters.moreFilters}</Button>;
    $[15] = dict.category.filters.moreFilters;
    $[16] = isPending;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== chips || $[19] !== dict) {
    t8 = chips.length ? <ResetFiltersButton chips={chips} dict={dict} /> : null;
    $[18] = chips;
    $[19] = dict;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== chips || $[22] !== t7 || $[23] !== t8) {
    t9 = <FilterChipBar chips={chips} className="mt-6 hidden md:flex">{t7}{t8}</FilterChipBar>;
    $[21] = chips;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setShowOffCanvas(true);
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== dict.category.filters.showFilters || $[27] !== isPending) {
    t11 = <Button priority={true} size={ButtonSize.MEDIUM} onClick={t10} icon={IconName.TUNE} disabled={isPending} className="md:hidden w-full mt-6">{dict.category.filters.showFilters}</Button>;
    $[26] = dict.category.filters.showFilters;
    $[27] = isPending;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setShowOffCanvas(false);
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setShowOffCanvas(false);
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== dict || $[32] !== facets || $[33] !== numFound) {
    t14 = <OffcanvasFilters facets={facets} dict={dict} onCloseClick={t13} numFound={numFound} />;
    $[31] = dict;
    $[32] = facets;
    $[33] = numFound;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== showOffCanvas || $[36] !== t14) {
    t15 = <OffCanvas position="right" isOpen={showOffCanvas} handleClose={t12}>{t14}</OffCanvas>;
    $[35] = showOffCanvas;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t11 || $[39] !== t15 || $[40] !== t5 || $[41] !== t9) {
    t16 = <>{t5}{t9}{t11}{t15}</>;
    $[38] = t11;
    $[39] = t15;
    $[40] = t5;
    $[41] = t9;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
};
export default HeaderFiltersClient;